import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_invoice,
  get_invoice,
  update_invoice,
} from "../../../../Controllers/Sales/Invoices";
import {
  get_quote,
} from "../../../../Controllers/Sales/Quotes";
import forms from "../../../../Data/Forms/Sales/Invoices/forms";
import headers from "../../../../Data/Forms/Sales/Invoices/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import Invoicetable from "../../../../Data/Forms/Sales/Invoices/table";
import dayjs from "dayjs";

const InvoicesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();


  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);

  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const moduleName = pathParts[2];

  const isQuotation = moduleName === "sales" ? true : false;

  const getFilteredFormOptions = () => {
    const baseForm = forms[0];

    if (id) {
      return [baseForm];
    } else {
      const filteredOptions = baseForm.options.filter(
        (option) => option.name !== "Status"
      );

      return [
        {
          ...baseForm,
          options: filteredOptions,
        },
      ];
    }
  };

  const [values, setValues] = useState(getFilteredFormOptions());
  const [note, setNote] = useState();

  const focus = useRef([]);

  const [details, setDetails] = useState([
    {
      id: "",
      description: null,
      name: "",
      unit: "",
      unit_name: "",
      unit_details_options: null,
      conversion: 0,
      quantity: "",
      invoice: "",
      invoice_price: "",
      invoice_options: null,
      delivered: "",
      tax: 0,
      free: "",
      barcode: "",
      price_per_unit: "",
      discounted_price: "",
      discounted_percentage: "",
      sale_price: "",
      expiry_date: "",
      tax_amount: "0.000",
      total: 0,
      source: "Sales"
    },
  ]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    discount_value: 0,
    discount_type: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: dayjs(),
    payment_status: 2,
    payment_types: ["Cash"],
    payments: {
      Cash: "",
      "Debit card": "",
      "Credit card": "",
      "Bank transfer": "",
      "Online payment": "",
      Cheque: "",
    },
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const findFieldIndex = (fieldName) => {
    return values[0].options.findIndex((option) => option.name === fieldName);
  };

  const detailsvalidation = (tabledata) => {
    let params = {};

    if (details?.length > 0) {
      let total = details?.length;
      let count = 0;

      let validated = [];
      details?.map((v, i) => {
        if (count == i) {
          if (!v?.description) {
            document.getElementById(
              `description${i}`
            ).textContent = `Description is required`;
            focus.current[`description${i}`].current.focus();
          } else if (!v?.sale_price) {
            document.getElementById(
              `sale_price${i}`
            ).textContent = `Sale price is required`;
            focus.current[`sale_price${i}`].current.focus();
          } else if (!v?.quantity) {
            document.getElementById(
              `quantity${i}`
            ).textContent = `Quantity is required`;
            focus.current[`quantity${i}`].current.focus();
          } else {
            document.getElementById(`description${i}`).textContent = ``;
            document.getElementById(`sale_price${i}`).textContent = ``;
            document.getElementById(`quantity${i}`).textContent = ``;

            validated?.push(v);
            count++;
          }
        }
      });

      if (count == total) {
        params = {
          status: true,
          data: {
            ...tabledata,
            details: validated,
          },
        };

        return params;
      } else {
        params = {
          status: false,
          data: null,
        };

        return params;
      }

    } else {
      toast?.error("Details not found");
    }
  };

  const totalsvalidation = (tabledata) => {
    let params = {};

    let count_totals = 0;

    if (totals?.delivery_status == 2 && !totals?.delivery_date) {
      document.getElementById(
        `delivery_date`
      ).textContent = `Delivery Date is required`;
      focus.current[`delivery_date`].current.focus();
    } else if (totals?.payment_status && !totals?.payment_types?.length) {
      document.getElementById(
        `payment_types`
      ).textContent = `Payment type is required`;
      focus.current[`payment_types`].current.focus();
    } else {
      if (totals?.delivery_status == 2) {
        document.getElementById(`delivery_date`).textContent = ``;
      }
      if (totals?.payment_status) {
        document.getElementById(`payment_types`).textContent = ``;
      }
      count_totals++;
    }

    if (count_totals) {
      let total_payment_types = totals?.payment_types?.length;
      let count_payment_types = 0;

      let total_amount = 0;
      if (totals?.payment_types?.length > 0) {
        totals?.payment_types?.map((v, i) => {
          if (count_payment_types == i) {
            if (!totals?.payments?.[v]?.amount) {
              document.getElementById(`${v}`).textContent = `${v} is required`;
              focus.current[`${v}`].current.focus();
            } else {
              total_amount =
                parseFloat(total_amount || 0) +
                parseFloat(totals?.payments?.[v]?.amount || 0);
              document.getElementById(`${v}`).textContent = ``;
              count_payment_types++;
            }
          }
        });

        if (total_amount == 0 && !tabledata?.customer) {
          toast?.error("Customer required for credit");
        } else {
          if (count_payment_types == total_payment_types) {
            params = {
              status: true,
              data: {
                ...tabledata,
                id: id ? id : "",
                subtotal: totals?.subtotal,
                taxamount: totals?.taxamount,
                discount_value: totals?.discount_value,
                discount_type: totals?.discount_type,
                discount: totals?.discount,
                delivery: totals?.delivery,
                delivery_status: totals?.delivery_status,
                delivery_date: totals?.delivery_date,
                payment_status: totals?.payment_status,
                payment_types: totals?.payment_types,
                payments: totals?.payments,
                total: totals?.total,
                note: note,
                source: "Sales"
              },
            };
            return params;
          } else {
            params = {
              status: false,
              data: null,
            };

            return params;
          }
        }
      } else {
        params = {
          status: true,
          data: {
            ...tabledata,
            id: id ? id : "",
            subtotal: totals?.subtotal,
            taxamount: totals?.taxamount,
            discount_value: totals?.discount_value,
            discount_type: totals?.discount_type,
            discount: totals?.discount,
            delivery: totals?.delivery,
            delivery_status: totals?.delivery_status,
            delivery_date: totals?.delivery_date,
            payment_status: totals?.payment_status,
            payment_types: totals?.payment_types,
            payments: totals?.payments,
            total: totals?.total,
            note: note,
            source: "Sales"
          },
        };

        return params;
      }
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      const tabledetailsvalidation = detailsvalidation(data?.data);

      if (tabledetailsvalidation?.status) {
        const tabletotalvalidation = totalsvalidation(
          tabledetailsvalidation?.data
        );

        if (tabletotalvalidation?.status) {
          setButtonLoader(true);
          const invoice = id
            ? await update_invoice(tabletotalvalidation?.data)
            : await create_invoice(tabletotalvalidation?.data);
          if (invoice?.status) {
            navigate(-1);
            toast?.success(invoice?.message);
            setButtonLoader(false);
          } else {

            const payload = {
              ...tabletotalvalidation?.data,
              id: id,
            };

            const quoteConvert = await create_invoice(payload);

            if (quoteConvert?.status) {
              navigate(-1);
              toast?.success(invoice?.message);
              setButtonLoader(false);
            } else {
              setButtonLoader(false);
              if (invoice?.status_code == 403) {
                window.location.href = "/unauthorized";
              } else {
                toast?.error(invoice?.message);
              }
            }
          }
        }
      }
    }
  };

  const handleData = (invoice) => {
    let customer = invoice?.customer?._id ? invoice?.customer?._id : null;
    let number = isQuotation ? "" : invoice?.number ? invoice?.number : "";
    let date = invoice?.date ? invoice?.date : "";
    let due_date = invoice?.due_date ? invoice?.due_date : "";
    let lpo_number = invoice?.lpo_number ? invoice?.lpo_number : "";
    let lpo_date = invoice?.lpo_date ? invoice?.lpo_date : "";
    let salesman = invoice?.salesman?._id ? invoice?.salesman?._id : null;
    let status = invoice?.status ? invoice?.status : 0;

    let salesman_options = invoice?.salesman?._id
      ? [
        {
          value: invoice?.salesman?._id,
          label: invoice?.salesman?.name,
        },
      ]
      : null;

    let customer_option = invoice?.customer?._id
      ? [
        {
          value: invoice?.customer?._id,
          label:
            invoice?.customer?.name && invoice?.customer?.phone
              ? invoice?.customer?.name +
              " (" +
              invoice?.customer?.phone +
              ")"
              : invoice?.customer?.name
                ? invoice?.customer?.name
                : invoice?.customer?.phone
                  ? invoice?.customer?.phone
                  : "",
        },
      ]
      : null;

    const currentValues = [...values];

    const customerIndex = findFieldIndex("Customer");
    const numberIndex = findFieldIndex("Number");
    const dateIndex = findFieldIndex("Date");
    const dueDateIndex = findFieldIndex("Due Date");
    const lpoNumberIndex = findFieldIndex("LPO Number");
    const lpoDateIndex = findFieldIndex("LPO Date");
    const salesmanIndex = findFieldIndex("Salesman");
    const statusIndex = findFieldIndex("Status");

    if (customerIndex !== -1) {
      currentValues[0].options[customerIndex].form.value = customer;
      currentValues[0].options[customerIndex].form.options = customer_option;
    }

    if (numberIndex !== -1) {
      currentValues[0].options[numberIndex].form.value = number;
    }

    if (dateIndex !== -1) {
      currentValues[0].options[dateIndex].form.value = date;
    }

    if (dueDateIndex !== -1) {
      currentValues[0].options[dueDateIndex].form.value = due_date;
    }

    if (lpoNumberIndex !== -1) {
      currentValues[0].options[lpoNumberIndex].form.value = lpo_number;
    }

    if (lpoDateIndex !== -1) {
      currentValues[0].options[lpoDateIndex].form.value = lpo_date;
    }

    if (salesmanIndex !== -1) {
      currentValues[0].options[salesmanIndex].form.value = salesman;
      currentValues[0].options[salesmanIndex].form.options = salesman_options;
    }

    if (statusIndex !== -1) {
      currentValues[0].options[statusIndex].form.value = status;
    }

    let data = [];

    invoice?.details?.map((value, index) => {
      let stock = value?.description?.stock;

      if (value?.unit != value?.description?._id) {
        value?.inventory_unit_details?.map((v, i) => {
          if (value?.unit == v?._id) {
            stock = v?.stock;
          }
        });
      }

      data?.push({
        id: value?._id,
        type:value?.typeModel === "services" ? "service" : value?.typeModel === "inventory" ? "inventory" : null,
        description: value?.description?._id,
        batch: value?.description?.number,
        expiry_date: value?.description?.expiry_date,
        category: value?.description?.product?.category ? value?.description?.product?.category : null,
        stock: stock,
        name: value?.name,
        unit: value?.unit,
        unit_name: value?.unit_name,
        unit_details_options: value?.unit_details_options,
        conversion: value?.conversion,
        invoice_price: value?.invoice_price,
        quantity: value?.quantity,
        delivered: value?.delivered,
        free: value?.free,
        tax_details: value.tax ? value.tax : null,
        tax: value?.tax?.name ? value?.tax?.name : null,
        barcode: value?.barcode,
        price_per_unit: value?.price_per_unit,
        sale_price: value?.sale_price,
        discount_price: value?.discount_price,
        discount_percentage: value?.discount_percentage,
        retail_price: value?.description?.product?.sale_price ? value?.description?.product?.sale_price : value?.sale_price ? value?.sale_price : 0,
        expiry_date: value?.expiry_date,
        tax_amount: value?.tax_amount,
        total: value?.total,
      });
    });

    let payment_types = [];
    let payments = {};
    invoice?.payments?.map((v, i) => {
      payment_types?.push(v?.name);
      payments[v?.name] = { id: v?._id, amount: v?.amount };
    });

    totals.subtotal = invoice?.subtotal;
    totals.taxamount = invoice?.taxamount;
    totals.discount_value = invoice?.discount_value;
    totals.discount_type = invoice?.discount_type;
    totals.discount = invoice?.discount;
    totals.delivery = invoice?.delivery;
    totals.delivery_status = invoice?.delivery_status;
    totals.delivery_date = invoice?.delivery_date;
    totals.payment_status = invoice?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.total = invoice?.total;

    setValues(currentValues);
    setDetails([...data]);
    setTotals({ ...totals });
    setNote(invoice?.note);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);
      if (invoice?.status) {
        handleData(invoice?.data);
      } else {

        const quotation = await get_quote(data);

        if (quotation?.status) {
          handleData(quotation?.data)
        }
        else {
          toast?.error(invoice?.message);
        }
      }
    } else {
      const filteredValues = getFilteredFormOptions();

      const dateIndex = findFieldIndex("Date");
      const dueDateIndex = findFieldIndex("Due Date");

      if (dateIndex !== -1) {
        filteredValues[0].options[dateIndex].form.value = new Date();
      }

      if (dueDateIndex !== -1) {
        // filteredValues[0].options[dueDateIndex].form.value = new Date();
      }

      setValues(filteredValues);

      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;

      setTotals({ ...totals });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Details"} required={true} />
              <Invoicetable
                details={details}
                setDetails={setDetails}
                totals={totals}
                setTotals={setTotals}
                ref={focus}
                note={note}
                setNote={setNote}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default InvoicesForm;
